const fastAbortBatch = (batch, aborts) => {
  batch.items.forEach(({
    id
  }) => aborts[id]?.());
};
const fastAbortAll = aborts => {
  Object.values(aborts).forEach(fn => fn());
};
export { fastAbortAll, fastAbortBatch };